import {Injectable, TemplateRef} from "@angular/core";

// holds the single shared TemplateRef used to render [safeTooltip] HTML content inside the
// ng-zorro tooltip. registered once by AppComponent; ng-zorro escapes plain string content, so HTML
// markup has to be rendered through a template (bound with [innerHTML]).
@Injectable({providedIn: "root"})
export class SafeTooltipTemplateService {
    content: TemplateRef<any> | null = null;
}
